// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__status-card-container__Dk1eB {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}
.index-module__status-card-container__Dk1eB .index-module__section1__A6M3Y,
.index-module__status-card-container__Dk1eB .index-module__section2__EN7Hi {
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-module__status-card-container__Dk1eB .index-module__label1__pVX7A {
  font-size: 12px;
  margin-right: 2px;
}
.index-module__status-card-container__Dk1eB .index-module__label2__IP3hf {
  font-size: 12px;
}
.index-module__status-card-container__Dk1eB .index-module__status__cI8xF {
  font-size: 16px;
  margin-left: 8px;
}
.index-module__dot__QHVmm {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.index-module__greenDot__Tyju0 {
  background-color: green;
}
.index-module__redDot__i6Qyi {
  background-color: red;
}
.index-module__blackDot__QWdOE {
  background-color: black;
}
.index-module__text-color-green___V8un {
  color: green;
}
.index-module__text-color-red__xtU5i {
  color: red;
}
.index-module__text-color-black__q2iDU {
  color: black;
}
.index-module__status-container__dw_f0 {
  margin-left: 10px;
  display: flex;
  align-items: center;
}
.index-module__status-text__TOIB_ {
  margin-left: 5px;
  font-size: 10px;
}
.index-module__createdOn-date__rFEyE {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PLCGWStatusCard/index.module.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;AACA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB","sourcesContent":[".status-card-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 20px;\n}\n.status-card-container .section1,\n.status-card-container .section2 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.status-card-container .label1 {\n  font-size: 12px;\n  margin-right: 2px;\n}\n.status-card-container .label2 {\n  font-size: 12px;\n}\n.status-card-container .status {\n  font-size: 16px;\n  margin-left: 8px;\n}\n.dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n.greenDot {\n  background-color: green;\n}\n.redDot {\n  background-color: red;\n}\n.blackDot {\n  background-color: black;\n}\n.text-color-green {\n  color: green;\n}\n.text-color-red {\n  color: red;\n}\n.text-color-black {\n  color: black;\n}\n.status-container {\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n}\n.status-text {\n  margin-left: 5px;\n  font-size: 10px;\n}\n.createdOn-date {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status-card-container": `index-module__status-card-container__Dk1eB`,
	"section1": `index-module__section1__A6M3Y`,
	"section2": `index-module__section2__EN7Hi`,
	"label1": `index-module__label1__pVX7A`,
	"label2": `index-module__label2__IP3hf`,
	"status": `index-module__status__cI8xF`,
	"dot": `index-module__dot__QHVmm`,
	"greenDot": `index-module__greenDot__Tyju0`,
	"redDot": `index-module__redDot__i6Qyi`,
	"blackDot": `index-module__blackDot__QWdOE`,
	"text-color-green": `index-module__text-color-green___V8un`,
	"text-color-red": `index-module__text-color-red__xtU5i`,
	"text-color-black": `index-module__text-color-black__q2iDU`,
	"status-container": `index-module__status-container__dw_f0`,
	"status-text": `index-module__status-text__TOIB_`,
	"createdOn-date": `index-module__createdOn-date__rFEyE`
};
export default ___CSS_LOADER_EXPORT___;
